import { axios, addHeader } from '@/api/index.js'

const contactUs = {
  submitEnquiry: (payload, accessToken) => {
    return axios.post('/contactus/submitEnquiry', payload, addHeader(accessToken))
  },
  getAdditionalInfo: accessToken => {
    return axios.get('/contactus/getAdditionalInfo', addHeader(accessToken), { params: null })
  },
  getEnquiryTypes: accessToken => {
    return axios.get('/contactus/getEnquiryTypes', addHeader(accessToken), { param: null })
  },
}

export default contactUs
